<template>
  <v-row class="d-flex justify-center mt-0 pt-4">
    <v-col cols="12" class="d-flex justify-center pt-4 pb-10">
      <!-- <img
        src="../assets/logo.webp"
        :height="$vuetify.breakpoint.xs ? 80 : 160"
      > -->
      <img
        src="/Eurodycar.webp"
        :height="$vuetify.breakpoint.xs ? 80 : 160"
      >
    </v-col>
    <v-col cols="12" sm="5" md="3" xl="2">
      <v-card>
        <v-card-title>
          Iniciar sesión
        </v-card-title>
        <v-card-text>
          <v-form ref="form" @submit.prevent="login()">
            <v-text-field
              v-model="user"
              label="E-mail"
              append-icon="fas fa-user"
              :rules="[rules.required, rules.email]"
              validate-on-blur
              outlined
              dense
            ></v-text-field>
            <v-text-field
              v-model="pass"
              label="Contraseña"
              type="password"
              append-icon="fas fa-lock"
              :rules="[rules.required]"
              validate-on-blur
              outlined
              dense
            ></v-text-field>
            <div class="d-flex justify-end">
              <v-btn
                type="success"
                color="success"
                :loading="laod"
              >
                Ingresar
                <v-icon right>fas fa-sign-in-alt</v-icon>
              </v-btn>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data () {
    return {
      laod: false,
      user: '',
      pass: '',
      rules: {
        required: value => !!value || 'Campo requerido',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'E-mail inválido'
        },
      },
    }
  },
  methods: {
    async login () {
      if (this.$refs.form.validate()) {
        this.laod = true
        await this.$store.dispatch('login', {
          email: this.user,
          password: this.pass,
        })
          .then(async () => {
            await this.$router.push('/')
          })
          .catch((error) => {
            this.$swal.fire({
              icon: 'error',
              title: 'Error al iniciar sesión',
              text: error,
            })
          })
        this.laod = false
      }
    }
  }
}
</script>